module.exports = __webpack_public_path__ + "img/9788959760527.dc0af996.jpg";